import { render, staticRenderFns } from "./ZakazkaVymaz.vue?vue&type=template&id=3cf36782&"
import script from "./ZakazkaVymaz.vue?vue&type=script&lang=ts&"
export * from "./ZakazkaVymaz.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports